// import "./badbank.css"
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useContext, useState } from "react";
import userContext from "./context.js";
import FloatingLabel from 'react-bootstrap/FloatingLabel';

export default function Create(){
 
  const [name,setName]=useState()
  const [email,setEmail]=useState()
  const [pass,setPass]=useState()

  const [val,setVal]=useState("none")
  const [vale,setVale]=useState("block")
  const [fom,setFom]=useState('block')

  
  const Username=useContext(userContext);


  function handle(e){
    e.preventDefault(); 
   
 alert("login successfully")
 
 Username.users=[...Username.users,{Name:name,Email:email,balance:0}]
 
document.getElementById('name').value="";

document.getElementById('email').value="";
document.getElementById('pass').value="";

setVal("block")
setVale("none")
setFom("none")
  }
   
    return(
    <div id="create">
    <Card id="form-card"><br></br>
      <h1>Create Account</h1>
    <Card.Body>
    <Form className='for' style={{display:`${fom}`}} onSubmit={(e)=>handle(e)}>
    
      <FloatingLabel controlId="floatingName" label="Name">
        <Form.Control type="text" id="name" placeholder="Name" onChange={e=>setName(e.target.value)} required />
      </FloatingLabel><br></br>
    <FloatingLabel
        controlId="floatingInput"
        label="Email address"
        className="mb-3"
      >
        <Form.Control type="email" id="email" placeholder="name@example.com"  onChange={e=>setEmail(e.target.value)} required />
      </FloatingLabel>
      <FloatingLabel controlId="floatingPassword" label="Password" >
        <Form.Control type="password" id="pass" placeholder="Password" onChange={e=>setPass(e.target.value)} required minLength="8"  />
      </FloatingLabel><br></br>
      <center>
      <Button type="submit" id="btm" disabled={!(name,email,pass)} style={{display:`${vale}`}} value="Create account">Create account</Button>
      </center>
    </Form>
    <center>
    <Button variant="primary" id="ad"style={{display:`${val}`}} onClick={()=>{setFom("block");setVal("none");setVale("block")}}  type="button">Add account</Button>
    </center>
    </Card.Body>
    </Card>
    </div>
    )
}
